









import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ExpressionOperatorKinds, IDateComparisonExpressionBehavior, IDateComparisonExpressionContent } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { DateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";

@Component
export default class DateComparisonExpressionBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (write: (source: IDateComparisonExpressionBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateComparisonExpressionBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get items(): IDateComparisonExpressionContent[] {
    return this.readPropertyOrDefault(s => s.contents, []);
  }

  set items(value: IDateComparisonExpressionContent[]) {
    this.writePropertyWhenValid(s => s.contents = value);
  }

  get settableItems(): IDateComparisonExpressionContent[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjects)
      .where(o => o.objectTypeName().getValue() === "date"
        && (o as DateObjectEditor).isDate().getValue())
      .select(o => this.toIDateComparisonExpressionContent(o as DateObjectEditor))
      .where(s => !!s.reference.key).toArray();
  }

  async showDateComparisonExpressionEditDialog() {
    const dialog = this.commonComponents.getDialogs().getDateComparisonExpressionEditDialog();
    const items = this.fillDateComparisonExpressionName(this.settableItems, this.items);
    const settingItems = await dialog.show(this.settableItems, items);
    if (!settingItems) { return; }
    this.items = settingItems;
  }

  private toIDateComparisonExpressionContent(object: DateObjectEditor): IDateComparisonExpressionContent {
    return {
      reference: {
        type: object.objectTypeName().getValue(),
        id: object.id().getValue(),
        key: object.isHisInformationItem ? object.hisInformationKey().getValue() : object.name().getValue(),
        isDate: true,
      },
      operator: ExpressionOperatorKinds.LessThan,
      name: object.isHisInformationItem ? object.getHisInformationName() : object.name().getValue(),
    };
  }

  private fillDateComparisonExpressionName(settableItems: IDateComparisonExpressionContent[], items: IDateComparisonExpressionContent[]): IDateComparisonExpressionContent[] {
    Enumerable.from(items).forEach(i => {
        const target = Enumerable.from(settableItems)
          .firstOrDefault(s => i.reference.key === s.reference.key);
        if (!!target) {
          i.name = target.name;
        } 
    });
    return items;
  }
}
